import { extractShortLanguage } from '@gem/modules/i18n';

import { getLanguage } from './getLanguage';

export function getUserLanguage(): string {
  return extractShortLanguage(getLanguage());
}
